<template>
  <div class="balloon balloon-text" @click.shift.left.exact="bubbleShift">
    unsupport
  </div>
</template>

<script>
export default {
  name: 'PayloadUnsupport',
  props: {
    conversation: Object
  },
  data() {
    return {
      message: {},
      sender: ''
    }
  },
  watch: {
    conversation: {
      immediate: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender
      }
    }
  },
  methods: {
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    }
  }
}
</script>
